"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Experience_1 = require("./Experience");
var JsonHandler_1 = require("./util/jsonloader/JsonHandler");
var experience = new Experience_1.Experience(JsonHandler_1.PlatformType.Browser);
var app = {
    // Application Constructor
    initialize: function () {
        document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
    },
    // deviceready Event Handler
    //
    // Bind any cordova events here. Common events are:
    // 'pause', 'resume', etc.
    onDeviceReady: function () {
        StatusBar.hide();
        this.receivedEvent('deviceready');
    },
    // Update DOM on a Received Event
    receivedEvent: function (id) {
        var experience = new Experience_1.Experience(JsonHandler_1.PlatformType.Mobile);
    }
};
// app.initialize();
